import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "5", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m9 20 3-6 3 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6 8 6 2 6-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 10v4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PersonStanding";
const PersonStanding = memo(themed(Icon));
export {
  PersonStanding
};
//# sourceMappingURL=person-standing.js.map
